"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _usePreferredLocale = _interopRequireDefault(require("@sprinx/react-globalize/usePreferredLocale"));

var _Loader = _interopRequireDefault(require("@sprinx/react-loader/Loader"));

var _reactGoogleMaps = require("react-google-maps");

var B = (0, _reactGoogleMaps.withScriptjs)(function (_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
});
B.displayName = 'GoofleMapInitializatorScripts';
B.propTypes = {
  children: _propTypes.default.node
};
B.defaultProps = {
  children: null
};

var _ref3 = /*#__PURE__*/_react.default.createElement(_Loader.default, {
  loading: true
});

function GoogleMapApiInitializator(_ref2) {
  var children = _ref2.children,
      googleApiKey = _ref2.googleApiKey;
  var lng = (0, _usePreferredLocale.default)();
  var Wrapper = googleApiKey ? B : _react.default.Fragment;
  var wrapperProps = googleApiKey ? {
    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=".concat(googleApiKey, "&v=3.exp&libraries=geometry,drawing,places&language=").concat(lng),
    loadingElement: _ref3
  } : {};
  return /*#__PURE__*/_react.default.createElement(Wrapper, wrapperProps, children);
}

process.env.NODE_ENV !== "production" ? GoogleMapApiInitializator.propTypes = {
  children: _propTypes.default.node,
  googleApiKey: _propTypes.default.string
} : void 0;
GoogleMapApiInitializator.defaultProps = {
  children: null,
  googleApiKey: undefined
};
var _default = GoogleMapApiInitializator;
exports.default = _default;